import { render, staticRenderFns } from "./CatalogAvailability.vue?vue&type=template&id=0b7fb182"
import script from "./CatalogAvailability.vue?vue&type=script&lang=js"
export * from "./CatalogAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports